import { createReducer } from 'typesafe-actions'
import { IInstrument } from '@sparling/financial-common'
import {
  currentInstrument,
  getTradableInstrumentsFailure,
  getTradableInstrumentsRequest,
  getTradableInstrumentsSuccess,
  instrumentPriceUpdate,
} from '../actions'
import { ActionTypes } from '../types'
import { LoadingState } from '../../types'

export type InstrumentsState = {
  currentInstrument: string | null
  tradableInstruments: {
    status: LoadingState
    data: IInstrument[]
    error: Error | null
  }
}

export const initialState: InstrumentsState = {
  currentInstrument: null,
  tradableInstruments: {
    status: 'IDLE',
    data: [],
    error: null,
  },
}

export const instruments = createReducer<InstrumentsState, ActionTypes>(initialState)
  .handleAction(currentInstrument, (state, { payload }) => ({
    ...state,
    currentInstrument: payload,
  }))
  .handleAction(getTradableInstrumentsRequest, (state) => ({
    ...state,
    tradableInstruments: {
      ...state.tradableInstruments,
      status: 'LOADING',
    },
  }))
  .handleAction(getTradableInstrumentsSuccess, (state, { payload: { data } }) => ({
    ...state,
    tradableInstruments: {
      ...state.tradableInstruments,
      status: 'SUCCESS',
      data,
    },
  }))
  .handleAction(getTradableInstrumentsFailure, (state, { payload }) => ({
    ...state,
    tradableInstruments: {
      ...state.tradableInstruments,
      status: 'ERROR',
      error: payload,
    },
  }))
  .handleAction(instrumentPriceUpdate, (state, { payload }) => ({
    ...state,
    tradableInstruments: {
      ...state.tradableInstruments,
      data: state.tradableInstruments.data.map((instrument) =>
        instrument.name === payload.instrument ? { ...instrument, ...payload } : instrument,
      ),
    },
  }))
